'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STARTED = exports.STARTED = 'STARTED';
var SUCCEEDED = exports.SUCCEEDED = 'SUCCEEDED';
var FAILED = exports.FAILED = 'FAILED';
var UNINITIALIZED = exports.UNINITIALIZED = 'UNINITIALIZED';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-clients/static-1.4266/js/action-creators/constants/RequestActionTypes.js
// module id = 681
// module chunks = 2 3